@if (language$ | async; as language) {
<button
  type="button"
  class="dropdown-button"
  (click)="toggleDropdown()"
  (keyup.Escape)="closedByKey()"
  (clickOutside)="closeDropdown()"
  ipoClickOutside
  data-test-id="language-chooser"
>
  <div class="selected-option">
    <img
      [src]="languageMap[language].icon"
      class="option-icon"
      [alt]="languageMap[language].label + ' icon'"
    />
    <span>{{ languageMap[language].label }}</span>
    <gc-icon
      [iconName]="'chevronDown'"
      [size]="'small'"
      class="toggle-icon"
      [ngClass]="{ expanded }"
      [ariaLabel]="'information'"
    ></gc-icon>
  </div>
</button>
@if (expanded) {
<div @listFadeAnimation class="dropdown-container">
  @for (option of languages; track option; let optionIndex = $index) {
  <div
    (click)="onOptionClick($event, option)"
    class="option"
    data-test-id="test-option"
  >
    <div class="selected-option">
      <img
        [src]="languageMap[option].icon"
        class="option-icon"
        [alt]="languageMap[option].label + ' icon'"
      />
      <span>{{ languageMap[option].label }}</span>
    </div>
  </div>
  }
</div>
} }
